import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage } from "@/i18n";

export default function LanguageSwitcher({ onChange, className = "" }) {
  const { i18n } = useTranslation();
  const cur = (i18n.language || "fr").startsWith("en") ? "en" : "fr";
  return (
    <div className={`inline-flex items-center gap-1 bg-[#F9F6F0] rounded-full p-1 border border-[#E5E0D8] ${className}`} data-testid="language-switcher">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          data-testid={`lang-${l.code}`}
          onClick={() => { setLanguage(l.code); onChange?.(l.code); }}
          className={`h-8 px-3.5 rounded-full text-xs font-bold transition-colors ${cur === l.code ? "bg-[#1B4332] text-white" : "text-[#5C574F]"}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
